import CustomMedia from 'util/custom-media-query';
import { css } from 'styled-components';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import SelectField from 'components/common/SelectField';
import DatepickerField from 'components/common/DatepickerField';
import Tooltip from 'components/OrderAggregators/Purchase/components/Tooltip';
import { pcStyle as tablePCStyle, spStyle as tableSPStyle } from './table';
import { GEditHoverStyle, GConfirmHoverStyle } from 'components/common/Button';

export const commonStyle = css`
  padding: 0 16px;
  box-shadow: 0 0 0 1px ${Colors.gray2};

  .header-panel {
    height: 88px;
    display: flex;
    align-items: center;

    h2 {
      ${FontStyles.text3};

      width: 20%;
      margin: 0 auto 0 0;
      color: ${Colors.black1};
    }

		.notice {
      ${FontStyles.text12};

      width: 80%
      margin: 0 0 0 auto;
      color: ${Colors.black1};
			padding-left: 1em;
			text-indent: -1em;
		}

    button {
      flex-shrink: 0;
    }
  }

  .btn-toggle {
    padding: 0;
    margin-right: 16px;
    background-color: transparent;
    border: 0;
    outline: none;
    appearance: none;
    cursor: pointer;
  }

  .order-content {
    overflow: hidden;
    max-height: 1260px;
    transition: max-height 0.6s ease;

    &.close {
      max-height: 0 !important;
    }
  }

  .order-footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media all and (-ms-high-contrast: none) and (min-width:1025px) {
    *::-ms-backdrop, .expired-end {
      height:42px;
    }

    *::-ms-backdrop, img.expire-from-to {
      padding-bottom: 55px;
    }

    *::-ms-backdrop, table {
      width: 100%;
      table-layout: fixed;
    }
  
    *::-ms-backdrop, tr {
      height: 64px;
      border-top: 1px solid ${Colors.gray3};
    }

    *::-ms-backdrop, &:last-of-type {
      border-bottom: 1px solid ${Colors.gray3};
    }

    *::-ms-backdrop, .row-thick {
      height: 96px;
    }
    
    *::-ms-backdrop, .td {
      padding-top: 16px;
    }

    *::-ms-backdrop, .row-variable {
      min-height: 64px;
      
      *::-ms-backdrop, td {
        padding: 16px;
      }
    }

    *::-ms-backdrop, .required-cell-wrapper {
      display: flex;
      align-items: center;
    }

    *::-ms-backdrop, th {
      text-align: left;
    }

    *::-ms-backdrop, td {
      text-align: left;
    }

    *::-ms-backdrop, th {
      ${FontStyles.text8};

      width: 168px;
      padding-left: 16px;
      background-color: ${Colors.gray4};
    }

    *::-ms-backdrop, i {
      display: inline-block;
      margin-left: 8px;
    }

    *::-ms-backdrop, td {
      ${FontStyles.text7};
      position: relative;
      padding: 20px 16px;
    }
  }
  
  @media all and (-ms-high-contrast: none) and (max-width:1024px) {
    *::-ms-backdrop, table {
      width: 100%;
      border: 0;
      table-layout: fixed;  
    }
    *::-ms-backdrop, th {
      display: block;
      text-align: left;
      border: 0;
    }
    *::-ms-backdrop, td {
      display: block;
      text-align: left;
      border: 0;
    }
    *::-ms-backdrop, th {
      ${FontStyles.text8};

      display: flex;
      align-items: center;
      height: 48px;
      padding-left: 8px;
      background-color: ${Colors.gray4};
      border-top: 1px solid ${Colors.gray3};
    }
    *::-ms-backdrop, i {
      display: inline-block;
      margin-left: 8px;
    }
    *::-ms-backdrop, td {
      display: inline-block;
      margin-left: 8px;
    }
    *::-ms-backdrop, td {
      ${FontStyles.text7};

      position: relative;
      min-height: 64px;
      padding: 16px 8px;
    }
    *::-ms-backdrop, $.confirm-table {
      border-bottom: 1px solid ${Colors.gray3};
    }
    *::-ms-backdrop, .ic_date {
      width: 30px;
    }
  }
`;

export const pcStyle = CustomMedia.greaterThan('umedium')`
  ${tablePCStyle};

  margin-bottom: 32px;

  .header-panel {
    height: 88px;

    .header-btn {
      margin: 0 16px;
    }
  }

  .order-content {
    min-width: 375px;
  }

  .order-footer {
    height: 88px;
  }

  table {
    .has-dialog:hover{
      cursor: pointer;

      .G-edit {
        ${GEditHoverStyle};
      }

      .G-confirm {
        ${GConfirmHoverStyle};
      }

      ${Tooltip} {
        opacity: 1;
        visibility: visible;
      }
    }


    ${Tooltip} {
      opacity: 0;
      visibility: hidden;
      transition: all 0.1s ease;
    }

    .wrapping-type {
      margin-right: 12px;
    }

    .wrapping-info-inscription {
      margin-right: 8px;
    }

    ${SelectField},
    ${DatepickerField} {
      display: inline-block;
      width: 174px;
      margin: 0 0 8px;

      &.disabled {
        width: 118px;
        margin: 0;
      }

      input,
      select {
        ${FontStyles.text7};
      }
    }

    ${DatepickerField} input:disabled {
      padding: 0;
      background-color: ${Colors.white1};
      background-image: none;
      color: ${Colors.black1};
      -webkit-text-fill-color: ${Colors.black1};
      opacity: 1;
      box-shadow: none;
      cursor: not-allowed;
    }

    .validity-period {
      display: flex;
      align-items: center;

      img {
        margin: 0 8px;
      }
    }

    .purchase-num {
      ${FontStyles.text7};
    }

    .notification {
      ${FontStyles.text10};

      display: block;
      margin-top: -4px;
    }

    .cell-wrapper {
      display: flex;
      align-items: flex-start;
    }

    .value {
      ${FontStyles.text7};

      display: block;
      width: 100%;
      margin: 0;
      color: ${Colors.black1};

      &.ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &.multiline {
        white-space: pre-wrap;
      }

      &.empty {
        color: ${Colors.gray2};
      }

      & + button {
        margin: 0 0 0 24px;
        flex-shrink: 0;
      }
    }
  }

  .regular-weight {
    font-weight: normal;
  }
`;

export const spStyle = CustomMedia.lessThan('medium')`
  ${tableSPStyle};

  margin-bottom: 16px;

  .header-panel {
    height: 64px;

    .header-btn {
      margin: 0;
    }
  }

  .order-footer {
    height: 72px;
    border-top: 1px solid ${Colors.gray3};
  }

  table {
    ${Tooltip} {
      opacity: 0;
      visibility: hidden;
    }

    .wrapping-type {
      margin-right: 12px;
    }

    .wrapping-info-inscription {
      margin-right: 8px;
    }

    ${SelectField},
    ${DatepickerField} {
      display: inline-block;
      width: 172px;
      padding: 0;
      margin: 0 0 12px;

      &.disabled {
        width: 130px;
        margin: 0;

        input {
          font-size: 15px;
        }
      }

      input,
      select {
        ${FontStyles.text5};
      }
    }

    ${DatepickerField} input:disabled {
      padding: 0;
      background-color: ${Colors.white1};
      background-image: none;
      color: ${Colors.black1};
      -webkit-text-fill-color: ${Colors.black1};
      opacity: 1;
      box-shadow: none;
      cursor: not-allowed;
    }

    .validity-period {
      ${DatepickerField}:first-child {
        margin-right: 4px;
      }

      img {
        margin-right: 4px;
      }
    }

    .purchase-num {
      ${FontStyles.text5};
    }

    .notification {
      ${FontStyles.text6};

      display: block;
      margin-top: 4px;
      margin-bottom: 16px;
    }

    .cell-wrapper {
      display: flex;
      align-items: flex-start;
    }

    .value {
      ${FontStyles.text5};

      display: block;
      width: 100%;
      margin: 0;
      color: ${Colors.black1};

      &.ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &.multiline {
        white-space: pre-wrap;
      }

      &.empty {
        color: ${Colors.gray2};
      }

      & + button {
        margin-left: 16px;
        flex-shrink: 0;
      }
    }
  }

  .regular-weight {
    font-weight: normal;
  }
`;



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/styles/order.js